<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="dialog"
        :close-on-confirm="false"
        :cons="cons"
        :hide-close="showProductDetails"
        :hide-confirm="showProductDetails"
        :persistent="showProductDetails"
        max-width="920"
        @close="$emit('close')"
      >
        <transition mode="out-in" name="slide-x-transition">
          <div v-if="!showProductDetails" key="list" class="pa-2">
            <v-tabs v-model="tabs">
              <v-tab v-for="(cat, i) in value" :key="i">
                <v-avatar
                  v-if="!!cat.color || !!cat.picture"
                  :color="cat.color"
                  class="ml-2"
                  size="32"
                >
                  <v-img v-if="cat.picture" :src="cat.picture" contain />
                </v-avatar>
                <v-icon v-else right>mdi-archive-plus</v-icon>

                {{ cat.name }}
              </v-tab>
            </v-tabs>
            <v-divider class="mt-0" />

            <v-tabs-items
              v-if="temp_items && temp_items[tabs] && temp_items[tabs].products"
              v-model="tabs"
            >
              <v-tab-item v-for="(cat, i) in value" :key="i">
                <custom-tabs v-model="configTabs" :tab-items="tabitem" grow>
                  <template v-slot:helpinfo="{ tab }">
                    <help-info
                      v-if="tab && tab.value && tab.text"
                      :element-name="`${serviceName}-${componentName}-data-${tab.value}-${i}`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="`${tab.text}`"
                    />
                  </template>
                  <template v-slot:middle>
                    <v-divider />
                  </template>

                  <template v-slot:staticItems>
                    <v-tab-item>
                      <v-row class="pa-2" no-gutters>
                        <v-col class="text-left" cols="12">
                          <div class="rowinfo">
                            <v-btn
                              class="rounded-lg contentinfo"
                              color="success"
                              outlined
                              small
                              @click="showCategories = true"
                            >
                              <v-icon left>mdi-plus</v-icon>
                              {{ $t("productPicker.select_default_product") }}
                            </v-btn>
                            <help-info
                              :element-name="`${serviceName}-${componentName}-show-categories`"
                              :service-name="serviceName"
                              :help-data="helpData"
                              class="buttoninfo"
                              :label="
                                $t('productPicker.select_default_product')
                              "
                            />
                          </div>

                          <special-category-product-picker
                            v-model="temp_items[tabs]"
                            :show.sync="showCategories"
                          />
                        </v-col>

                        <v-col
                          v-for="(product, i) in temp_items[tabs].products"
                          :key="i"
                          class="pa-2"
                          cols="12"
                          lg="4"
                          md="6"
                        >
                          <v-card
                            class="rounded-lg"
                            outlined
                            @click="editProduct(i)"
                          >
                            <v-list-item>
                              <v-list-item-avatar>
                                <img
                                  :alt="product.name"
                                  :src="product.gallery | getProductImage"
                                />
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="three-line-truncate"
                                  v-text="product.name"
                                />
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="red"
                                      icon
                                      v-bind="attrs"
                                      v-on="on"
                                      @click.stop="deleteProduct(i)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  {{ $t("productOptionEditor.actions.delete") }}
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>

                    <v-tab-item>
                      <special-category-editor v-model="temp_items[tabs]" />
                    </v-tab-item>
                  </template>
                </custom-tabs>
              </v-tab-item>
            </v-tabs-items>
          </div>

          <div v-else key="details">
            <special-product-editor
              v-if="temp_items && temp_items[tabs] && temp_items[tabs].products"
              v-model="temp_items[tabs].products[editIndex]"
              @close="
                () => {
                  editIndex = null;
                  showProductDetails = false;
                }
              "
            />
          </div>
        </transition>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import SpecialProductEditor from "@/view/components/adapters/specialCategory/specialProductEditor.vue";
import SpecialCategoryEditor from "@/view/components/adapters/specialCategory/specialCategoryEditor.vue";
import SpecialCategoryProductPicker from "@/view/components/adapters/specialCategory/specialCategoryProductPicker.vue";
import { mapState } from "vuex";

export default {
  name: "specialCategoryProductManager",

  components: {
    SpecialCategoryProductPicker,
    SpecialCategoryEditor,
    SpecialProductEditor,
  },

  props: {
    value: Array,
    show: Boolean,
    selectedIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "special-category-product-manger",
      showProductDetails: false,
      temp_items: null,
      configTabs: 0,
      showCategories: false,
      tabs: 0,
      editIndex: null,
    };
  },

  mounted() {
    this.tabs = this.selectedIndex;
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    tabitem() {
      return [
        { text: this.$t("products"), value: "products", icon: "sign-yield" },
        {
          text: this.$t("editCategory"),
          value: "edit-category",
          icon: "pencil",
        },
      ];
    },
    cons() {
      return {
        title: this.$t("add_edit_products"),
        buttons: [{ type: "submit", handler: this.syncProducts }],
      };
    },

    dialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },

  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.temp_items = [...newVal];
       if (newVal && oldVal && newVal.length > oldVal.length) {
        this.$nextTick(() => {
          this.tabs = newVal.length - 1; 
          
        });
      }        }
      },
      deep: true
    },
    show(val) {
   this.temp_items = JSON.parse(JSON.stringify(this.value));
      
      this.$nextTick(() => {
        if (this.selectedIndex !== null && this.selectedIndex !== undefined) {
          this.tabs = this.selectedIndex;
        } else if (this.temp_items && this.temp_items.length > 0) {
          this.tabs = this.temp_items.length - 1;
        } else {
          this.tabs = 0;
        }
      });
    },
  },

  methods: {
    editProduct(index) {
      this.editIndex = index;
      this.showProductDetails = true;
    },
    syncProducts() {
      this.loading = true;

      let products = this.temp_items.reduce((arr, curr) => {
        curr.products.forEach((item) => {
          arr.push(item);
        });

        return arr;
      }, []);

      if (
        products.some((item) => Object.keys(item).some((key) => !item[key]))
      ) {
        this.$toast.error(this.$t("enter_param_product"));
        return;
      }

      this.$api
        .put("v1/testQr/category-special-sync-products", {
          qr_id: this.createQrID,
          products_id: products,
        })
        .then(({ data }) => {
          this.dialog = false;
          this.$emit("fetch");
          this.$root.$emit("fetchSpecialCategory");
        })
        .catch(({ response }) => {
          console.log("failed to sync products: ", response);
          try {
            if (response?.data?.errors?.length)
              response.data.errors.forEach((item) => {
                this.$toast.error(item);
              });
          } catch (e) {
            console.log(e);
          }
        })
        .finally(() => (this.loading = false));
    },
    async deleteProduct(index) {
      let item = this.temp_items?.[this.tabs]?.products[index];

      if (await this.$modal.yesNo("تایید حذف محصول؟")) {
        this.loading = true;

        if (!!item.id) {
          this.$api
            .delete(`v1/testQr/category-special-delete-Product/${item.id}`, {
              params: {
                qr_id: this.createQrID,
              },
            })
            .then(({ data }) => {
              this.$toast.success("با موفقیت حذف شد");
              this.temp_items?.[this.tabs]?.products.splice(index, 1);
            })
            .catch(({ response }) => {
              this.$toast.error("خطا در حذف محصول!");
              console.log("failed to delete product: ", response);
            })
            .finally(() => (this.loading = false));
        } else this.temp_items?.[this.tabs]?.products.splice(index, 1);
      }
    },
  },
};
</script>

<style>
.popup-content .v-tabs-slider-wrapper {
  display: block !important;
}

.three-line-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}
</style>
